import React, { LegacyRef, useState } from "react";
import { Tag } from "./Tag";
import { classSelectors } from "../../../../hooks/selectors";
type Tags = { id?: number; display_name: string; test_value?: string; icon_path?: string }[];

export interface ReactTagInputProps {
  id?: string;
  tags: Tags;
  onChange: React.Dispatch<React.SetStateAction<Tags>>;
  placeholder?: string;
  maxTags?: number;
  validator?: (val: string) => boolean;
  readOnly?: boolean;
  targetRef?: LegacyRef<HTMLInputElement> | undefined;
  isOnlyTag?: boolean;
}

interface State {
  input: string;
}

export default function ReactTagInput(props: ReactTagInputProps) {
  const [state, setState] = useState<State>({ input: "" });
  const inputRef: React.RefObject<HTMLInputElement> = React.createRef();

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({ input: e.target.value });
  };

  const onInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const { input } = state;
    const { validator } = props;

    if (e.code === "Enter" || e.code === "Space" || e.code === "Tab") {
      e.preventDefault();
      if (input === "") {
        return;
      }
      const valid = validator !== undefined ? validator(input) : true;
      if (!valid) {
        return;
      }
      addTag(input);
    }
  };

  const onInputBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { input } = state;
    const { validator } = props;
    e.preventDefault();
    if (input === "") {
      return;
    }
    const valid = validator !== undefined ? validator(input) : true;
    if (!valid) {
      return;
    }
    addTag(input);
  };

  const addTag = (value: string) => {
    const tags = [...props.tags];
    if (tags.every((tag) => tag.display_name !== value)) {
      props.onChange((prev) => [...prev, { display_name: value }]);
    }
    setState({ input: "" });
  };

  const removeTag = (i: number) => {
    const tags = [...props.tags];
    tags.splice(i, 1);
    props.onChange(tags);
    inputRef?.current && inputRef.current.focus();
  };

  // const updateTag = (i: number, value: string) => {
  //   const tags = [...props.tags];
  //   const numOccurencesOfValue = tags.reduce(
  //     (prev, currentValue, index) => prev + (currentValue === value && index !== i ? 1 : 0),
  //     0,
  //   );
  //   if (numOccurencesOfValue > 0) {
  //     tags.splice(i, 1);
  //   } else {
  //     tags[i] = value;
  //   }
  //   props.onChange(tags);
  // };

  const { input } = state;

  const { id, tags, placeholder, maxTags, readOnly, targetRef = null, isOnlyTag = true } = props;

  const maxTagsReached = maxTags !== undefined ? tags.length >= maxTags : false;

  const showInput = !readOnly && !maxTagsReached;

  return (
    <div className={classSelectors.wrapper} style={{ maxHeight: "100%" }}>
      {isOnlyTag
        ? tags.map((tag, i) => <Tag key={i} value={tag} index={i} readOnly={readOnly || false} remove={removeTag} />)
        : tags.map((tag, i) =>
            tag?.id ? (
              <Tag key={i} value={tag} index={i} readOnly={readOnly || false} remove={removeTag} />
            ) : (
              tag.display_name
            ),
          )}

      {showInput && (
        <input
          id={id}
          type="email"
          ref={targetRef ? targetRef : inputRef}
          value={input}
          className={classSelectors.input}
          placeholder={placeholder || ""}
          onChange={onInputChange}
          onKeyDown={onInputKeyDown}
          onBlur={onInputBlur}
        />
      )}
    </div>
  );
}
